import plCatalog from '../../../po/pl_PL.po'
/**
 * Run method for main CMS module. Here we'll continue configuration using services.
 *
 * @function cmsRun
 * @memberOf cms.MainModule
 */
/** @ngInject */
export default function cmsRun(
    gettextCatalog,
    CMSAuthService,
    ACLService,
    $http,
    $rootScope,
    AuthDialogService,
    languageManager,
    PasswordChangeService,
    toastrConfig,
    $transitions,
    SaveWarning,
    toastr
) {

    gettextCatalog.setStrings("pl", plCatalog.pl_PL);
    gettextCatalog.setCurrentLanguage(languageManager.getLanguage());

    angular.extend(toastrConfig, {
        preventOpenDuplicates: true,
        timeOut: 3000
    });
    // Check auth token on app load
    if (CMSAuthService.getToken() && typeof CMSAuthService.getInvalidateLogin() !== 'undefined') {
        CMSAuthService.setHttpAuth();
    } else {
        window.location.href = "/login.html";
    }

    // Check auth token on location change
    $rootScope.$on('$locationChangeStart', function () {
        if (!CMSAuthService.getToken()) {
            window.location.href = "/login.html";
        }
    });


    // Check if first login
    $rootScope.$on('$locationChangeStart',() => {
        if (CMSAuthService.getUser() && !CMSAuthService.getUser().resetPasswordAt) {
            PasswordChangeService.open();
        }
    });

    // Event from angular-http-auth
    $rootScope.$on('event:auth-loginRequired', function() {
        AuthDialogService.open();
    });


    let criteriaAuthorizationState = {
        entering: (state) => state.data && state.data.requiresAuth
    };

    $transitions.onStart(criteriaAuthorizationState, (transition) => {
        let requiredRoles = transition.to().data.requiresAuth;
        let allow = ACLService.matchRoles(requiredRoles);
        if(!allow) {
            toastr.error(
                gettextCatalog.getString('This action is locked for your account type'),
                gettextCatalog.getString('Contente free account')
            );
            return transition.router.stateService.target(transition.from().name);
        }
    });


    const criteriaObjEdit = {
        from: (state) => state.name.includes('Edit')
    };

    $transitions.onExit(criteriaObjEdit, () => {
        return SaveWarning.isEdited();
    });

    const criteriaObjAdd = {
        from: (state) => state.name.includes('Add')
    };

    $transitions.onExit(criteriaObjAdd, () => {
        return SaveWarning.isEdited();
    });
}


// WEBPACK FOOTER //
// ./src/mainModule/js/cmsRun.js